import { getVertexId } from '../../core/util';
import type { CoreTypes } from '../../core';
import type { Types as SduiTypes } from '../types';

export default (
  teacher: CoreTypes.Mixed.Teacher,
  options: SduiTypes.options
): SduiTypes.teacher => {
  let firstname: string | undefined;
  let lastname:  string | undefined;

  if (teacher.person && !(typeof teacher.person == 'string')) {
    if ('firstName' in teacher.person) firstname = teacher.person.firstName;
    if ('lastName'  in teacher.person) lastname  = teacher.person.lastName;
  }
  return {
    id: getVertexId(teacher, options),
    // shortcut: teacher.displayName,
    ...firstname && { firstname },
    ...lastname  && { lastname  }
  };
};
